import { useCallback, useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { GetFinancialReportAction } from '@/application/actions';
import type { FinancialReportDTO } from '@/domain/repositories/IReportRepository';

export const useFinancialReport = () => {
  const [report, setReport] = useState<FinancialReportDTO | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<GetFinancialReportAction>(TYPES.GetFinancialReportAction);
      setReport(await action.execute());
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load financial report'));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { report, isLoading, error, refetch: load };
};
